import { AdminTreeProjectSubType, AdminTreeProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import ForestryIcon from "@ecologi/assets/icons/ProjectInsights/forestry.svg";

export const reforestationVisuals: Record<
  AdminTreeProjectType,
  ProjectVisualsType
> = {
  REFORESTATION: {
    icon: <ForestryIcon />,
    pictogram: `/images/app/forest/carbon_avoidance/pictograms/forestry.svg`,
  },
};

export const reforestationSubTypeVisuals: Record<
  AdminTreeProjectSubType,
  ProjectVisualsType
> = {
  GLOBAL_REFORESTATION: reforestationVisuals.REFORESTATION,
  UK_REFORESTATION: reforestationVisuals.REFORESTATION,
  US_REFORESTATION: reforestationVisuals.REFORESTATION,
  BRAZIL_REFORESTATION: reforestationVisuals.REFORESTATION,
  AUSTRALIA_REFORESTATION: reforestationVisuals.REFORESTATION,
};
